import React from 'react';

import Link from '@/components/switchback/Link/Link';
import { IPageCategory } from '@/services/getHelpPageData';

import css from './Articles.module.css';

interface ICategoriesProps {
  articles: IPageCategory[];
}
const Articles: React.FC<ICategoriesProps> = ({ articles }) => {
  if (!articles || !articles.length) {
    return null;
  }
  return (
    <ul className={css.links}>
      {articles.map(category => {
        return (
          <li key={category.id}>
            <Link href={`/help/${category?.slug}`} className={css.item}>
              <a
                dangerouslySetInnerHTML={{ __html: category.title || '' }}
                className="font-normal body-sm"
              />
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default Articles;
